import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

import { Candidate } from '@pflegia/data-access';
import { FilterValue } from '@pflegia/types/api/job-board/filter-value';
import { useAuth } from '@pflegia/ui/contexts/auth.context';

import { UPDATE_CANDIDATE_BASED_ON_FILTERS } from '@shared/graphql/mutations';

export const useSideBarState = () => {
  const authenticated = useAuth();

  const [updateCandidateFilters, { loading }] = useMutation<{ data: Candidate }, { filters?: FilterValue[] }>(
    UPDATE_CANDIDATE_BASED_ON_FILTERS,
  );

  const handleUpdateCandidateFilters = useCallback(
    async (filters?: FilterValue[]) => {
      if (authenticated) {
        await updateCandidateFilters({ variables: { filters } });
      }
    },
    [authenticated, updateCandidateFilters],
  );

  return {
    isLoading: loading,
    updateCandidateFilters: handleUpdateCandidateFilters,
  };
};
